<template>
    <v-flex sm8 offset-sm2>

        <v-card width="480px" class="mx-auto">
            <v-toolbar color="#B3A8A8">
                <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>


            <v-form ref="form" class="pa-3" @keyup.native.enter="login">
                <v-text-field class="pt-6" dense v-model="username" :clearable="true" label="Username" :rules="[rules.required, rules.minNameLen]" required></v-text-field>
                <v-text-field class="pt-6" dense v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, rules.min]"
                    :type="show1 ? 'text' : 'password'" name="input-10-1" label="Password" counter @click:append="show1 = !show1" :clearable="true" required>
                </v-text-field>
                <v-container fluid>
                    <v-row justify='end' no-gutters>
                        <v-col class="text-right">
                            <v-btn class="px-3 mt-3" @click.prevent="login" color="#B3A8A8">Login</v-btn>       <!-- originar greenish color #CEE2DC -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
    </v-flex>
</template>

<script>
    export default {    
        name: "Login",    

        data () {
            return {
                show1: false,
                username: '',
                password: '',
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => (v && v.length >= 4) || 'Min 4 characters',
                    minNameLen: v => (v && v.length >= 3) || 'Minimum name length is 3 characters'
                },
            };
        },

        methods: {    
            async login() {                       
                if (this.$refs.form.validate()) {
                    this.$store.dispatch("login", {username: this.username, password: this.password}).then(() => {
                        
                        this.$socket.disconnect();
                        this.$socket.query = `token=${this.$store.state.token}`;
                        this.$socket.io.opts.query = `token=${this.$store.state.token}`;
                        this.$socket.connect();


                        this.$router.push({name: 'Security Control Center'});
                    }, error => {
                        this.$toasted.error(error.response.data.message, 
                            { theme: "toasted-primary", icon: 'alert-circle-outline', position: "top-center", duration : 1800 })
                    });
                }
                else {
                    this.$toasted.error("Please fix the highlighted errors!", 
                        { theme: "toasted-primary", icon: 'alert-circle-outline', position: "top-center", duration : 1800 }
                    );
                }
            }    
        }    
    }
</script>